import { LoaderProps } from './Loader.types';
import { Spinner } from '@integration/alexandria-ui';

export const Loader = ({
  dataTestId = 'loader',
  blurDepth,
  isLoading = false,
  force = false,
  fullSize = false,
  children,
}: LoaderProps) => {
  if (!isLoading && !force) {
    return null;
  }
  return (
    <Spinner data-testid={dataTestId} blurDepth={blurDepth} fullSize={fullSize}>
      {children}
    </Spinner>
  );
};

export default Loader;
